// stores/product.js
import { defineStore } from "pinia";
import { useFreeSearchGlobalStore } from "./freeSearchGlobal";
import VueInst from "@/main_app.js";
import { getCustomSortBooks } from "@/services/customSorts.js";
import * as bookList from "@/store/modules/bookList";
import * as vuexStore from "@/store/store";

import { getBookbyId as getBookById } from "@/store/modules/books.js";
import {
  getUserFreeSearchSavedList,
  userFreeSearchListDeleteBooks,
} from "@/services/userFoldersData.js";
import { getBookName, bookYears } from "@/services/bookData";
import * as history from "@/services/history.js";
import { getGzirimData } from "@/services/freeSearch.js";
import AVLTree from "@/utils/avl";

let currListCahceObj = {};

let booksIds = {};
let currentList = {};
let booksChecked = {};
let currListData = {};

export let customSortBooks = [];
export function createFreeSearchBookListStore(id, setActive = false) {
  if (!id) id = useFreeSearchGlobalStore().currentFreeSearch || "main";
  if (setActive) useFreeSearchGlobalStore().setCurrentFreeSearch(id);
  return defineStore(`freeSearchBookList-${id}`, {
    state: () => ({
      id: id,
      name: "",
      price: 0,
      details: null,
      textInput: "",
      searchInType: "",
      prevSearchInType: 1,
      focusInInput: 0,
      showList: false,
      currentFsSavedList: "",
      textSearch: "",
      finalTextSearch: "",
      hideBookLists: false,
      resultsType: "classic" /* classic, special, mefo   */,
      sortBy: "ideal",
      currentFilter: 0,
      booksCheckedRefresh: true,
      checkedBooksCount: 0,
      booksIdsRefresh: 0,
      currentFsName: "",
      dorot: [
        'מקרא וחז"ל',
        "ראשונים וקדמונים",
        'אחרונים ש-ת"ר',
        'אחרונים ת"ר -ת"ש',
        "אחרוני זמנינו",
        "אחרים",
      ],
      sortResults: [],
      totalResults: 0,
      currentSearchInType: 0,
      searchInBooks: [],
      prevSearchInBooks: [],
      currentHistoryId: 0,
      currentHistoryLastActive: 0,
      active: false,
      searchInTxt: "",
      currentListLength: 0,
      listFromSearchIn: false,
      dontScroll: false,
      gzirimMode: false,
      dontLoadGzirim: false,
      favoriteCheckBooksCount: 0,
      showSortResults: false,
      savedListName: "",
      customListAdded: false,
      historyUsersActions: {
        //the current action in history will be synchronized with the data to kn
        current: 1,
        isAddedToHistory: false,
        //array of all user's action
        data: [
          {
            type: "ALL",
            content: "",
          },
        ],
      },
      firstTimeSearch: true,
    }),
    getters: {
      getCurrentFreeSearchId(state) {
        return this.id;
      },
      getFirstTimeSearch(state) {
        return state.firstTimeSearch;
      },
      getFSListName(state) {
        return state.currentFsSavedList;
      },
      getFinalTextSearch(state) {
        return state.finalTextSearch;
      },
      getTextSearch(state) {
        return state.textSearch;
      },
      getCurrentListIds() {
        const retAgain = this.booksIdsRefresh;
        return booksIds[this.getCurrentFreeSearchId] || [];
      },
      getCurrentFilterName(state) {
        if (state.sortResults.length == 0) return "";
        if (state.currentFilter == 0) return "";

        return state.sortResults[state.currentFilter - 1].title;
      },
      getCurrentList(state) {
        let react = state.booksIdsRefresh;
        react = vuexStore.default.state.booksChanged;

        const showHide = vuexStore.default.state.bookList.showHiddenBooks;
        const enableHide = VueInst.userSettings.settings.enableHidden != "0";

        let cacheObj = {
          booksRef: state.booksIdsRefresh,
          booksChanged: react,
          txtSearch: state.searchInTxt,
          showHide,
          enableHide,
          currentFilter: state.currentFilter,
        };

        const cached = checkCacheForGCList(
          cacheObj,
          this.getCurrentFreeSearchId
        );

        if (cached)
          return { booksList: currListData[this.getCurrentFreeSearchId] || [] };

        let list = (currentList[this.getCurrentFreeSearchId] || []).filter(
          (item) => {
            let book;
            item.special ? (book = item.book) : (book = item);
            if (!book._show) return false;
            if (!showHide && enableHide && book._hide) return false;

            if (
              state.searchInTxt != "" &&
              !(
                book.name.includes(state.searchInTxt) ||
                book.volume.includes(state.searchInTxt) ||
                book.mainAuthorName.includes(state.searchInTxt)
              )
            )
              return false;

            if (
              (state.currentFilter > 0 &&
                (book.dor & (1 << (state.currentFilter - 1))) > 0) ||
              (book.dor == 0 && state.currentFilter == 6) ||
              state.currentFilter == 0
            )
              return true;
            else return false;
          }
        );
        let results = 0;

        if (state.resultsType == "special") results = list.length;
        else
          list.forEach((l) => {
            results += l.fs.results;
          });

        state.totalResults = results;
        state.currentListLength = list.length;

        currListData[this.getCurrentFreeSearchId] = list;
        currListCahceObj[this.getCurrentFreeSearchId] = cacheObj;
        return { booksList: list };
      },
      getBooksChecked() {
        let refresh = this.booksCheckedRefresh;
        return booksChecked[this.getCurrentFreeSearchId] || [];
      },
      getGzirim() {
        const retAgain = this.booksIdsRefresh;
        if (!booksIds[this.getCurrentFreeSearchId]) return [];
        return booksIds[this.getCurrentFreeSearchId].map((b) => {
          return {
            show: b.gzirim,
            results: b.gzirimData,
            numResults: b.results,
          };
        });
      },
      getDataOfCurrentList() {
        return {
          current: this.currentHistoryId,
          currentLastActive: this.currentHistoryLastActive,
        };
      },
      isSavedList(state) {
        return state.currentFsSavedList != "";
      },
      getCurrentFilterNumResults(state) {
        if (state.sortResults.length == 0) return -1;
        if (state.currentFilter == 0) return -1;
        return state.sortResults[state.currentFilter - 1].num;
      },
      getCheckedBooks(state) {
        const rootState = { userFavoriteBooks: {} };
        let x = rootState.userFavoriteBooks.favoriteChange;
        let checked = [];
        Object.keys(booksChecked[this.getCurrentFreeSearchId] || []).forEach(
          (key, index) => {
            let check = booksChecked[this.getCurrentFreeSearchId][key];
            if (check) checked.push(key);
          }
        );

        let fav = checked.filter((b) => {
          b = getBookById(parseInt(b), false);
          return !b.favorite === false;
        });

        state.favoriteCheckBooksCount = fav.length == checked.length ? 1 : 0;

        state.booksCheckedRefresh = !state.booksCheckedRefresh;
        return checked;
      },
    },
    actions: {
      setFirstTimeSearch(val) {
        this.firstTimeSearch = val;
      },
      refreshCurrentList() {
        currentList[this.getCurrentFreeSearchId] = [];

        //reset list according to hidden books \ active maagar\ filter by dor
        const showHide = vuexStore.default.state.bookList.showHiddenBooks;
        const enableHide = VueInst.userSettings.settings.enableHidden != "0";
        if (booksIds[this.getCurrentFreeSearchId])
          booksIds[this.getCurrentFreeSearchId].forEach((bookid, i) => {
            let book = getBookById(bookid.book, false);

            if (book == undefined) return;
            if (!book._show) return;
            if (!showHide && enableHide && book._hide) return;

            if (
              this.searchInBooks != "" &&
              !(
                book.name.includes(state.searchInBooks) ||
                book.mainAuthorName.includes(state.searchInBooks)
              )
            )
              return;

            //filter hidden books
            if (
              (this.currentFilter > 0 &&
                (book.dor & (1 << (this.currentFilter - 1))) > 0) ||
              (book.dor == 0 && this.currentFilter == 6) ||
              this.currentFilter == 0
            ) {
              book.index = i;
              if (this.currentFsName != "")
                book.fs = {
                  fs: state.currentFsName,
                  start: bookid.start,
                  end: bookid.end,
                  results: bookid.results,
                  matches: bookid.matchesNum,
                  rate: bookid.rate,
                  gzirim: bookid.gzirim != undefined ? bookid.gzirim : false,
                  bookref: bookid,
                };

              currentList.push(book);
            }
          });

        this.currentListLength = currentList.length;
        booksChecked[this.getCurrentFreeSearchId] = {};
        this.checkedBooksCount = 0;
        this.doBooksIdsRefresh();
        this.booksCheckedRefresh = !this.booksCheckedRefresh;
      },
      doBooksIdsRefresh() {
        this.booksIdsRefresh++;
      },
      async addUserActionToHistory(listData) {
        //if the action is SAVED_LIST
        if (listData.type === "SAVED_LIST") {
          //get the curr user action to compare

          //sedin to server get request to get the list of books of saved list
          this.setCurrentFSListName(listData.content);
          await getUserFreeSearchSavedList(listData.id);

          //than add the action to user's actions
          let curr = this.historyUsersActions.current;
          this.historyUsersActions.isAddedToHistory = false;
          this.historyUsersActions.current++;
          //insert new user action in the current place in the array
          this.historyUsersActions.data.splice(curr, 0, {
            ...listData,
          });
        }
        //SEARCH
        if (listData.type === "SEARCH") {
          //get the curr user action to compare
          let curr =
            this.historyUsersActions.data[this.historyUsersActions.current - 1];

          //if the curr type equel to the the data type
          if (curr.type == listData.type) {
            //and if its the same list id of books step out from addin and return
            if (curr.content == listData.content) return;
          }
          let forword =
            this.historyUsersActions.data[this.historyUsersActions.current];
          if (forword != undefined || forword != null) {
            if (forword.type == listData.type) {
              //and if its the same list id of books step out from addin and return
              if (forword.content == listData.content) return;
            }
          }
          //set content to text search
          listData.content = state.textSearch;
          //than add the action to user's actions
          curr = this.historyUsersActions.current;
          this.historyUsersActions.isAddedToHistory = false;
          this.historyUsersActions.current++;
          //insert new user action in the current place in the array
          this.historyUsersActions.data.splice(curr, 0, {
            ...listData,
          });
        }
      },
      setListFromSearchIn(val) {
        this.listFromSearchIn = val;
      },
      setCurrentHistoryId(val) {
        this.currentHistoryId = val;
      },
      setCurrentHistoryLastActive(val) {
        this.currentHistoryLastActive = val;
      },

      setHideBookLists(val) {
        this.hideBookLists = val;
      },
      setFinalTextSearch(val) {
        this.finalTextSearch = val;
      },
      setCurrentFsName(val) {
        this.currentFsName = val;
      },
      setTotalResults(val) {
        this.totalResults = val;
      },
      setShowSortResults(val) {
        this.showSortResults = val;
      },
      setCurrentFilter(val) {
        this.currentFilter = val;
      },
      setCustomListAdded(val) {
        this.customListAdded = val;
      },
      resetBooksToSearchIn() {
        this.searchInBooks = this.prevSearchInBooks;
      },
      async setSortByList(sort) {
        if (sort.startsWith("custom_")) {
          await this.getCustomSortBooks(sort.slice(7));
          this.sortBy = sort;
          //now sort
          this.doSort(sort);
          this.doBooksIdsRefresh();
        } else {
          this.sortBy = sort;
          //now sort
          this.doSort(sort);
          this.doBooksIdsRefresh();
        }
      },
      toggleShowResultsPopup() {
        this.showSortResults = !this.showSortResults;
      },
      toggleGzirim(index) {
        let gzirim = booksIds[this.getCurrentFreeSearchId][index]?.gzirim
          ? booksIds[this.getCurrentFreeSearchId][index].gzirim
          : false;
        booksIds[this.getCurrentFreeSearchId][index].gzirim = !gzirim;

        this.doBooksIdsRefresh();
      },
      setGzirim(show) {
        if (show) {
          this.dontLoadGzirim = true;
        }
        this.gzirimMode = show;
        if (!booksIds[this.getCurrentFreeSearchId]) return;
        booksIds[this.getCurrentFreeSearchId].forEach((b) => {
          b.gzirim = show;
        });
      },
      setGzirimData({ index, isList }) {
        //get data for gzirim
        getGzirimData(
          this.currentFsName,
          booksIds[this.getCurrentFreeSearchId][index].start,
          booksIds[this.getCurrentFreeSearchId][index].end,
          booksIds[this.getCurrentFreeSearchId][index].results,
          booksIds[this.getCurrentFreeSearchId][index].book,
          isList
        ).then((data) => {
          booksIds[this.getCurrentFreeSearchId][index].gzirimData = data;
          this.dontScroll = true;
          this.doBooksIdsRefresh();
        });
      },
      getBooksCheckedInfo() {
        if (!currentList[this.getCurrentFreeSearchId]) return [];
        let books = currentList[this.getCurrentFreeSearchId].filter(
          (book) => booksChecked[this.getCurrentFreeSearchId][book.id]
        );

        return books.map((book) => {
          let b = book.special ? book.book : book;
          return {
            book: b.id,
            numResults: b.fs ? b.fs.results : 0,
            start: b.fs ? b.fs.start : 0,
            end: b.fs ? b.fs.end : 0,
            name: getBookName(b.name, b.volume, true),
            author: b.mainAuthorName,
            places: b.places,
            years: bookYears(b),
          };
        });
      },
      async removeBooks({ books, booksIndex, fsData }) {
        if (
          fsData.id !== "special" ||
          (fsData.id === "special" && fsData.type === "list")
        )
          await userFreeSearchListDeleteBooks({
            books: booksIndex,
            fsData,
          });
        books.forEach((b) => {
          if (booksChecked[this.getCurrentFreeSearchId][b])
            this.checkedBooksCount--;
          delete booksChecked[this.getCurrentFreeSearchId][b];
        });
        booksIds[this.getCurrentFreeSearchId] = booksIds[
          this.getCurrentFreeSearchId
        ].filter((book) => !books.includes(book.book.toString()));
        currentList[this.getCurrentFreeSearchId] = currentList[
          this.getCurrentFreeSearchId
        ].filter((book) => !books.includes(book.id.toString()));

        this.doBooksIdsRefresh();
        this.booksCheckedRefresh = !this.booksCheckedRefresh;
      },
      updateCurrentListLastIndex(data) {
        this.currentHistoryLastActive = data.index;
        //update history in db (ignore unsuitable function name)
        history.setSearchHistoryPin({
          lastActive: data.index,
          id: this.currentHistoryId,
        });
      },
      checkBook({ book, check }) {
        booksChecked[this.getCurrentFreeSearchId][book] = check;
        this.booksCheckedRefresh = !this.booksCheckedRefresh;
        check ? this.checkedBooksCount++ : this.checkedBooksCount--;
      },
      toggleCheckBook({ book }) {
        if (booksChecked[this.getCurrentFreeSearchId][book]) {
          this.checkedBooksCount--;
          delete booksChecked[this.getCurrentFreeSearchId][book];
        } else {
          this.checkedBooksCount++;
          booksChecked[this.getCurrentFreeSearchId][book] = true;
        }
        this.booksCheckedRefresh = !this.booksCheckedRefresh;
      },
      revertChecks() {
        let books = this.getCurrentList;
        let count = 0;
        books.booksList.forEach((b) => {
          if (booksChecked[this.getCurrentFreeSearchId][b.id])
            delete booksChecked[this.getCurrentFreeSearchId][b.id];
          else {
            booksChecked[this.getCurrentFreeSearchId][b.id] = true;
            count++;
          }
        });

        this.checkedBooksCount = count;
        this.booksCheckedRefresh = !this.booksCheckedRefresh;
      },
      checkAllBooks(check) {
        let books = this.getCurrentList;
        if (!check) booksChecked[this.getCurrentFreeSearchId] = {};
        else
          books.booksList.forEach((b) => {
            booksChecked[this.getCurrentFreeSearchId][b.id] = check;
          });
        this.booksCheckedRefresh = !this.booksCheckedRefresh;

        check
          ? (this.checkedBooksCount = books.booksList.length)
          : (this.checkedBooksCount = 0);
      },
      setTextInput(txt) {
        this.textInput = txt;
      },
      setSearchInType(txt) {
        this.searchInType = txt;
      },
      setCurrentSearchInType(txt) {
        this.currentSearchInType = txt;
      },
      setPrevSearchInType(txt) {
        this.prevSearchInType = txt;
      },
      setBooksToSearchIn(val) {
        try {
          books.sort((a, b) => a - b);
        } catch (ex) {}
        this.searchInBooks = val;
      },
      toggleShowFreeSearchList() {
        this.showList = !this.showList;
      },
      setCurrentFSListName(val) {
        this.currentFsSavedList = val;
      },
      showFreeSearchList() {
        this.showList = true;
      },
      setSearchTxt(val) {
        this.textSearch = val;
      },
      setResultsType(val) {
        this.resultsType = val;
      },
      //set results books. fires list.
      async setResultBooks(books) {
        this.hideBookLists = true;
        let defaultSort = VueInst.userSettings.settings.defaultCustomSort;
        if (this.resultsType !== "classic") defaultSort = "book";
        if (defaultSort === undefined || defaultSort === "")
          defaultSort = "ideal";
        if (defaultSort.startsWith("custom_"))
          this.getCustomSortBooks(defaultSort.slice(7));

        this.sortBy = defaultSort;
        this.currentFilter = 0;
        currentList[this.getCurrentFreeSearchId] = [];
        booksIds[this.getCurrentFreeSearchId] = books;

        this.hideBookLists = false;
        this.setCurrentList(bookList.showHiddenBooks);
        this.doSort(this.sortBy);
        this.refreshChecks();
        this.doBooksIdsRefresh();
      },
      async getCustomSortBooks(title) {
        customSortBooks = await getCustomSortBooks(title);
        try {
          customSortBooks.forEach((sortList, i, arr) => {
            let avlsortList = new AVLTree();
            sortList.forEach((e) => {
              avlsortList.root = avlsortList.insert(avlsortList.root, e, e);
            });

            arr[i] = avlsortList;
          });
        } catch (ex) {
          console.error(ex.message);
          customSortBooks = [];
        }
      },
      setCurrentList(hide) {
        const showHide = hide;
        const enableHide = VueInst.userSettings.settings.enableHidden != "0";

        let sortResults = [0, 0, 0, 0, 0, 0];
        if (!booksIds[this.getCurrentFreeSearchId]) return;
        booksIds[this.getCurrentFreeSearchId].forEach((bookid, i) => {
          let b = getBookById(bookid.book, false);
          if (b == undefined) return;

          if (
            (showHide || !enableHide || (enableHide && b._hide === 0)) &&
            b._show
          ) {
            if (!b.dor) sortResults[5]++;
            else {
              for (let i = 1; i <= 5; i++) {
                let flag = 1 << (i - 1);
                if ((b.dor & flag) == flag) sortResults[i - 1]++;
              }
            }
          }

          b.index = i;

          if (this.currentFsName != "") {
            if (this.currentFsName == "special") {
              currentList[this.getCurrentFreeSearchId].push({
                book: b,
                position: bookid.position,
                special: true,
                result: bookid.txt,
                page: bookid.page,
                id: b.id,
                mainVolume: b.mainVolume,
                resultType: bookid.resultType,
              });
            } else {
              b.fs = {
                fs: this.currentFsName,
                start: bookid.start,
                end: bookid.end,
                results: bookid.results,
                matches: bookid.matchesNum,
                rate: bookid.rate,
                gzirim: bookid.gzirim != undefined ? bookid.gzirim : false,
                bookref: bookid,
              };
              currentList[this.getCurrentFreeSearchId].push(b);
            }
          }
        });

        this.sortResults = sortResults.map((r, i) => {
          return { type: "category", id: i + 1, num: r, title: this.dorot[i] };
        });
      },
      refreshChecks() {
        booksChecked[this.getCurrentFreeSearchId] = {};
        this.checkedBooksCount = 0;
        this.booksCheckedRefresh = !this.booksCheckedRefresh;
      },
      doSort(sort) {
        if (sort.startsWith("custom_")) {
          try {
            currentList[this.getCurrentFreeSearchId].forEach((c) => {
              c.sortValue = 9999;
            });
            currentList[this.getCurrentFreeSearchId].forEach(
              (book, index, arr) => {
                customSortBooks.forEach((sort, sortIndex) => {
                  let bookid = sort.get(sort.root, book.id);
                  if (bookid) {
                    if (arr[index].sortValue == 9999) {
                      arr[index].sortValue = sortIndex + 1;
                    }
                  }
                });
              }
            );
          } catch (ex) {
            console.error(ex.message);
          }

          //first sort by sys sort
          currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
            let a = fbook;
            let b = sbook;

            if (a.sortValue < b.sortValue) return -1; //a come first
            if (a.sortValue > b.sortValue) return 1;
            if (a.nameSort < b.nameSort) return -1; //a come first
            if (a.nameSort > b.nameSort) return 1;

            return -1;
          });
        } else {
          switch (sort) {
            case "ideal": {
              currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
                let a = fbook;
                let b = sbook;
                if (a.special) {
                  a = fbook.book;
                  b = sbook.book;
                }
                if (a.fs.rate < b.fs.rate) return -1; //a come first
                if (a.fs.rate > b.fs.rate) return 1;

                if (a.fs.matches > b.fs.matches) return -1; // a come first
                if (a.fs.matches < b.fs.matches) return 1;

                if (a.fs.results > b.fs.results) return -1; // a come first
                if (a.fs.results < b.fs.results) return 1;

                if (a.nameSort > b.nameSort) return 1;
                if (a.nameSort < b.nameSort) return -1;

                return -1;
              });

              break;
            }
            case "profile": {
              currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
                const a = fbook.special ? fbook.book : fbook;
                const b = sbook.special ? sbook.book : sbook;

                // Prioritize dor === 0 to the end
                if (a.dor === 0 && b.dor !== 0) return 1;
                if (b.dor === 0 && a.dor !== 0) return -1;

                // Sort by dor
                const dorDiff = a.dor - b.dor;
                if (dorDiff !== 0) return dorDiff;

                // Sort by nameSort (numeric)
                return a.nameSort - b.nameSort;
              });

              break;
            }
            case "rate": {
              currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
                let a = fbook;
                let b = sbook;
                if (a.special) {
                  a = fbook.book;
                  b = sbook.book;
                }
                if (a.fs.rate < b.fs.rate) return -1;
                if (a.fs.rate > b.fs.rate) return 1;

                if (a.nameSort > b.nameSort) return 1;
                if (a.nameSort < b.nameSort) return -1;

                return -1;
              });
              break;
            }
            case "results": {
              currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
                let a = fbook;
                let b = sbook;
                if (a.special) {
                  a = fbook.book;
                  b = sbook.book;
                }
                if (a.fs.results < b.fs.results) return 1;
                if (a.fs.results > b.fs.results) return -1;

                if (a.nameSort > b.nameSort) return 1;
                if (a.nameSort < b.nameSort) return -1;

                return -1;
              });
              break;
            }
            case "book": {
              currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
                let a = fbook;
                let b = sbook;
                if (a.special) {
                  a = fbook.book;
                  b = sbook.book;
                }

                if (a.name > b.name) return 1;
                if (a.name < b.name) return -1;

                if (a.mainVolume > b.mainVolume) return 1;
                if (a.mainVolume < b.mainVolume) return -1;
                if (fbook.special && fbook.position) {
                  if (fbook.position > sbook.position) return 1;
                  if (fbook.position < sbook.position) return -1;
                }
                if (a.position > b.position) return 1;
                if (a.position < b.position) return -1;

                return a.mainAuthorName > b.mainAuthorName ? 1 : -1;
              });
              break;
            }
            case "author": {
              currentList[this.getCurrentFreeSearchId].sort((fbook, sbook) => {
                let a = fbook;
                let b = sbook;
                if (a.special) {
                  a = fbook.book;
                  b = sbook.book;
                }
                if (a.authorSort > b.authorSort) return 1;
                if (a.authorSort < b.authorSort) return -1;
                return 0;
              });
              break;
            }
          }
        }
      },
    },
  })();
}

function checkCacheForGCList(data, getCurrentFreeSearchId) {
  let useCache = true;
  if (!currListCahceObj[getCurrentFreeSearchId]) return false;
  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i++) {
    if (data[keys[i]] != currListCahceObj[getCurrentFreeSearchId][keys[i]]) {
      useCache = false;
      break;
    }
  }
  return useCache;
}
